import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";

interface MergedRowChromeProps {
    merged: boolean;
    children: React.ReactNode;
    /** When true, show a small "Merged" badge (e.g. list rows). */
    showBadge?: boolean;
    className?: string;
}

/**
 * Subtle container for rows/cards that originated from a merged source space.
 */
export function MergedRowChrome({ merged, children, showBadge = false, className }: MergedRowChromeProps) {
    if (!merged) return <>{children}</>;

    return (
        <div
            className={cn(
                "rounded-md bg-muted/25 ring-1 ring-border/40 min-w-0",
                showBadge && "pt-1",
                className
            )}
        >
            {showBadge ? (
                <div className="flex justify-end px-2 pb-0.5">
                    <Badge variant="outline" className="text-[10px] h-5 px-1.5 font-normal text-muted-foreground">
                        Merged
                    </Badge>
                </div>
            ) : null}
            <div className="min-w-0">{children}</div>
        </div>
    );
}
